import TextField from '@mui/material/TextField';
import { Grid, InputAdornment } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { aiHighlightSx, aiIconSx, customFieldInputSx } from '../styles/CommonStyles';

const styles = {
    customFieldsBox: {
        backgroundColor: 'var(--spectre-surface)',
        mt: 1
    }
}

export default function CustomFieldNumberBox(props: any) {
    const { index, customField, updateCustomFieldSubmitValues, customFieldSubmitValues, isAiPopulated } = props

    return (
        <Grid item md={11} xs={11} sx={styles.customFieldsBox}>
            <TextField 
                color="primary" 
                type="number" 
                variant="outlined" 
                size="small" 
                label={customField.name}
                required={customField.required}
                value={customFieldSubmitValues['CustomFields']['Field'][index]['Value']} 
                fullWidth 
                onChange={(element) => { 
                    updateCustomFieldSubmitValues(index, element.target.value) 
                }}
                InputProps={isAiPopulated ? {
                    endAdornment: (
                        <InputAdornment position="end">
                            <AutoAwesomeIcon sx={aiIconSx} fontSize="small" />
                        </InputAdornment>
                    )
                } : {}}
                sx={{ ...customFieldInputSx, ...(isAiPopulated ? aiHighlightSx : {}) }}
            />
        </Grid>
    );
}